/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';
import type { TeamLogoResource } from './';
import {
    TeamLogoResourceFromJSON,
    TeamLogoResourceFromJSONTyped,
    TeamLogoResourceToJSON,
} from './';
import type { TeamSizeResource } from './';
import {
    TeamSizeResourceFromJSON,
    TeamSizeResourceFromJSONTyped,
    TeamSizeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientTeamProfileResource
 */
export interface ClientTeamProfileResource {
    /**
     * 
     * @type {string}
     * @memberof ClientTeamProfileResource
     */
    name?: string;
    /**
     * 
     * @type {TeamLogoResource}
     * @memberof ClientTeamProfileResource
     */
    logo?: TeamLogoResource;
    /**
     * 
     * @type {TeamSizeResource}
     * @memberof ClientTeamProfileResource
     */
    size?: TeamSizeResource;
    /**
     * 
     * @type {ActivityArea}
     * @memberof ClientTeamProfileResource
     */
    activityArea?: ActivityArea;
    /**
     * 
     * @type {string}
     * @memberof ClientTeamProfileResource
     */
    description?: string;
}

/**
 * Check if a given object implements the ClientTeamProfileResource interface.
 */
export function instanceOfClientTeamProfileResource(value: object): value is ClientTeamProfileResource {
    return true;
}

export function ClientTeamProfileResourceFromJSON(json: any): ClientTeamProfileResource {
    return ClientTeamProfileResourceFromJSONTyped(json, false);
}

export function ClientTeamProfileResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientTeamProfileResource {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'logo': json['logo'] == null ? undefined : TeamLogoResourceFromJSON(json['logo']),
        'size': json['size'] == null ? undefined : TeamSizeResourceFromJSON(json['size']),
        'activityArea': json['activityArea'] == null ? undefined : ActivityAreaFromJSON(json['activityArea']),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ClientTeamProfileResourceToJSON(value?: ClientTeamProfileResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'logo': TeamLogoResourceToJSON(value['logo']),
        'size': TeamSizeResourceToJSON(value['size']),
        'activityArea': ActivityAreaToJSON(value['activityArea']),
        'description': value['description'],
    };
}

